// util
import { getProvinceAndCity } from '~/util/common.util'
export const state = () => ({
  company: {},
  province: '',
  city: '',
  techSupport: {}
})

export const mutations = {
  setCompanyState(state, company) {
    const location = getProvinceAndCity(company.provice, company.city)
    state.province = location.province
    state.city = location.city
    state.company = company
  },
  setCompanyTechSupport(state, techSupport) {
    state.techSupport = techSupport
  }
}
